// built-in imports
import { motion } from "framer-motion";

// internal imports
import { Wrapper, SkillContainer, Skill } from "./skill-card.styles";
import { fadeIn } from "../../utils/motion/motion.utils";

const SkillCard = ({ icon, name }) => {
  return (
    <motion.div variants={fadeIn("", "", 0.1, 1)}>
      <Wrapper>
        <SkillContainer>
          <Skill>
            {icon}
            <p>{name}</p>
          </Skill>
        </SkillContainer>
      </Wrapper>
    </motion.div>
  );
};
export default SkillCard;
